import createSelector from 'web-app/util/custom-create-selector';

export const isUploading = createSelector(
    state => state.fileUpload.files,
    (_, props) => props.formId,
    (files, formId) =>
        Boolean(files.get(formId) && files.get(formId).filter(file => file.uploadProgress !== null).size),
);

export const numberOfFilesAddedToForm = createSelector(
    state => state.fileUpload.files,
    (_, props) => props.formId,
    (files, formId) => files.get(formId) && files.get(formId).size,
);
